import React, {Fragment} from "react";
import {Outlet, useLocation} from "react-router-dom";
import {useSelector} from "react-redux";
import {InformationModal} from "../../modal";
import {HeaderSection} from "../../headerSection";
import {urls} from "../../../business/routes/urls";

/** Pages that render their own full-viewport shell (own sidebar + topbar). */
const OWN_SHELL_PATHS = [urls.mcOpsDashboard];

export const PrivateRoutesLayout = () => {

    const modalData = useSelector(s => s.modalData);
    const location = useLocation();
    const ownShell = OWN_SHELL_PATHS.some(
        (path) => location.pathname === path || location.pathname.startsWith(path + "/")
    );

    return (
        <Fragment>
            {ownShell ? null : <HeaderSection/>}
            <Outlet/>
            <InformationModal
                isOpen={modalData?.isOpen}
                content={modalData?.content}
                style={modalData?.style}
            />


        </Fragment>
    );
}
